module.exports = __webpack_public_path__ + "img/icon-client-card-blue@3x.b8e18f81.png";